import { buildDialogUrl } from '@common/services';

function buildDisputeViewDrawerUrl(
  action: string,
  disputeCode: string,
  pathName: string
) {
  return buildDialogUrl('dispute-view-drawer', {
    props: { action, disputeCode },
    overlap: false,
    pathName,
  });
}

export const pathToInv = (invoiceId: string) => {
  return `/works/billing/invoices/${invoiceId}`;
};

export const pathToRevInv = (revInvoiceId: string) => {
  return `/works/supplier/billing/reverse-invoices/${revInvoiceId}`;
};

export const pathToInvDispute = ({
  invoiceId,
  selectedDispute,
}: {
  invoiceId: string;
  selectedDispute?: string;
}) =>
  buildDisputeViewDrawerUrl(
    'review',
    selectedDispute || '',
    `${pathToInv(invoiceId)}/disputes`
  );

export const pathToRevInvDispute = ({
  revInvoiceId,
  selectedDispute,
}: {
  revInvoiceId: string;
  selectedDispute?: string;
}) =>
  buildDisputeViewDrawerUrl(
    'review',
    selectedDispute || '',
    `${pathToRevInv(revInvoiceId)}/disputes`
  );

export const pathToRevInvItem = ({
  revInvoiceId,
}: {
  revInvoiceId: string;
}) => {
  return `${pathToRevInv(revInvoiceId)}/hours`;
};

export const pathToInvItem = ({ invoiceId }: { invoiceId: string }) => {
  return `${pathToInv(invoiceId)}/hours`;
};
